// extracted by mini-css-extract-plugin
export default {"postText":"FullPost_postText__RtUnK","buttons":"FullPost_buttons__0Opj2"};